import { setUser } from "@sentry/react";
import InternalHome from "./InternalHome";
import NoAccess from "./NoAccess";
import PublicHome from "./PublicHome";

const Home = ({ setAuth, userOrg, setUserOrg }) => {
  // Show loading while userOrg is being determined
  if (userOrg === null) {
    return (
      <div className="h-screen w-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-ktx-purple"></div>
      </div>
    );
  }

  return (
    <>
      {userOrg ? (
        userOrg === "Knowtex" ? (
          <InternalHome setAuth={setAuth} userOrg={userOrg} setUserOrg={setUserOrg} />
        ) : (
          <PublicHome setAuth={setAuth} userOrg={userOrg} setUserOrg={setUserOrg}/>
        )) : (
        <NoAccess setAuth={setAuth} setUserOrg={setUserOrg} />
      )}
    </>
  );
};

export default Home;